import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { MoveBillingitemsWizardEffectsV26 } from './effects';
import * as fromMoveBillingitemsWizard from './reducer';

export function provideMoveBillingitemsWizardStoreV26(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(fromMoveBillingitemsWizard.moveBillingitemsWizardFeatureKey, fromMoveBillingitemsWizard.reducer),
    provideEffects(MoveBillingitemsWizardEffectsV26),
  ]);
}
